import React from "react";
import PropTypes from "prop-types";
import CartDeleteBtn from "../molecules/components/CartDeleteBtn";
import CartQuantityInput from "../molecules/containers/CartQuantityInput";
import CartQuantityPriceInput from "../molecules/containers/CartQuantityPriceInput";

export const CartProduct = ({
  cartProduct,
  productCartQuantity,
  deleteCartProduct,
  orderType,
  currencySign
}) => {

  if (orderType === 'special') {
    return (
      <div className={"cartBar__item__body "}>
        <div className="cartBar__item__body__price">
          <div className="d-flex justify-content-center">
            <div className="productBox__body__price__edit__state">
              <CartQuantityPriceInput
                quantity={productCartQuantity}
                cartProduct={cartProduct}
              />
            </div>

            <CartDeleteBtn title="" deleteCartProduct={deleteCartProduct} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="cartBar__item__body d-flex justify-content-between">
      <div className="cartBar__item__body__price">
        {parseFloat(cartProduct.price).toFixed(2)} {currencySign}
      </div>
      <div className="d-flex justify-content-end">
        <CartQuantityInput
          quantity={productCartQuantity}
          cartProduct={cartProduct}
        />
        <CartDeleteBtn title="" deleteCartProduct={deleteCartProduct} />
      </div>
    </div>
  );
};
CartProduct.propTypes = {
  cartProduct: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      ean: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quantity: PropTypes.number.isRequired
    })
  ).isRequired,
  deleteCartProduct: PropTypes.func,
  productCartQuantity: PropTypes.number,
  orderType: PropTypes.string,
  currencySign: PropTypes.string,
};

export default CartProduct;



// WEBPACK FOOTER //
// ./src/components/CartProduct.js